export async function createCheckoutSession({
  email,
  uid,
  priceId,
  accountType = "personal",
}) {
  const response = await fetch("https://createcheckoutsession-25cvxlkrra-uc.a.run.app", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email,
      uid,
      priceId,
      accountType,
      returnBaseUrl: window.location.origin,
      brand: {
        name: "ManuCalc",
        flagship: "GD&T Helper",
        accentColor: "#8b5cf6",
        secondaryAccentColor: "#22d3ee",
        productDescription:
          "Premium dark manufacturing dashboard for GD&T, machining calculators, SOP process planning, Tool Database, and Manufacturing Plans.",
      },
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || "Failed to create checkout session");
  }

  if (!data.url) {
    throw new Error("No checkout URL returned from backend");
  }

  return data.url;
}

export async function redirectToCheckout({
  email,
  uid,
  priceId,
  accountType = "personal",
}) {
  const checkoutUrl = await createCheckoutSession({
    email,
    uid,
    priceId,
    accountType,
  });

  window.location.href = checkoutUrl;
}
